<template>
    <div class="deletebox">      
      <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="132px" labelPosition="center" class="registerform" hide-required-asterisk>      
        <!--当前密码      -->
        <el-form-item label="当前密码" prop="password">
          <el-input v-model="ruleForm.password" size="large" show-password></el-input>
        </el-form-item>
        <el-form-item label-width="0" class="submitbutton">
          <el-button type="primary" round  @click="submitForm('ruleForm')">注销</el-button>
        </el-form-item>
      </el-form>
    </div>

</template>

<script>
import { Message  } from 'element-ui';
import { mapActions } from 'vuex';
export default {

    data() {
	
      return {
		  
        ruleForm: {
          password:""      
        },
        rules: {		
          password:[
            { required: true, message: '请输入密码', trigger: 'blur' },
            { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
          ],         
        },
       
    		
      };
    },

    methods: {
      ...mapActions(['LoginOut']),
      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
			        this.$api.user.deleteUser(this.ruleForm).then(res=>{
                if(res.data.errno==0){
                  this.$FUnitls.showInfo("注销成功",'success')
                  // var options={
                  //   message:"注销成功",
                  // }
                  // Message.success(options)  
                  //this.disabled =true
                  this.LoginOut()  
                  this.$router.push({name:"index"})        
                }else{
                  // var options={
                  //   message:res.data.errmsg,
                  // }

                  this.$FUnitls.showInfo(res.data.errmsg,'error')
                 		
                }
              })
			    }else{
            return false;
          }
        });
      },
    }
  

}
</script>

<style scoped>
    .deletebox >>> .el-form--label-left .el-form-item__label{
      color: #333333;
      font-family: Arial, Helvetica, sans-serif;
      font-size: 16px;
      font-weight: 540;

      
    }
    .deletebox >>> .el-form-item__label{
        text-align: justify;
        text-align-last: justify;
        padding: 0 75px 0 0;
    }
    .deletebox >>> .el-input,.el-select{
      width: 380px;
    }
    .deletebox >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:before{
          content: '';
          color: #ff1111;
          font-size: 16px;
          margin-right: 4px;
          font-family: Microsoft YaHei,Heiti SC,tahoma,arial,Hiragino Sans GB,"\5B8B\4F53",sans-serif;
    }
    .deletebox >>> .el-form-item.is-required:not(.is-no-asterisk)>.el-form-item__label:after{
          /* content: ' ';
          color: #ff1111;
          background: url('/static/redstar.png') no-repeat center;
          background-size: 6px 6px;
          padding-right: 8px; */
           content: '*';
          color: #ff1111;
          font-size: 16px;
          margin-right: 4px;
          font-family: Microsoft YaHei,Heiti SC,tahoma,arial,Hiragino Sans GB,"\5B8B\4F53",sans-serif;
    }
	.xieyi{
		font-size: 14px;
		color: #9f9f9f;
	}
	.xieyi .yinsi{
		color:#2655ae;
	}
    .deletebox >>> .el-input.is-disabled .el-input__inner{
        background-color: #fff;
        color: #888888;
        border: 0px;
    }
    .deletebox >>> .el-input.is-disabled .el-icon-arrow-up:before{
        content:""
    }
    .submitbutton{
        text-align: center;
    }
    .deletebox >>> .el-form-item:last-child{
        margin-bottom: 0;
    }
</style>


// WEBPACK FOOTER //
// src/components/user/DeleteUserShow.vue